// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchInput_searchContainer__bSYWi","edit":"SearchInput_edit__+7pcj","searchInput":"SearchInput_searchInput__ok6yQ"};